import { render, staticRenderFns } from "./Stop.vue?vue&type=template&id=78c1263b&scoped=true&"
import script from "./Stop.vue?vue&type=script&lang=js&"
export * from "./Stop.vue?vue&type=script&lang=js&"
import style0 from "./Stop.vue?vue&type=style&index=0&id=78c1263b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c1263b",
  null
  
)

export default component.exports